<template>
	<div>
		<form autocomplete="off" id="productSelector" class="istores__buyout">
			<div class="row">
				<div class="col-12 buyoutTitle h2">
					{{ $t('buyout.search_for_device') }}
				</div>
			</div>
			<div class="row">
				<div class="col-md-4">
					<v-autocomplete
						id="categorySelector"
						v-model="selectedCategory"
						item-text="name"
						item-value="pk"
						:items="categories"
						:placeholder="$t('buyout.deviceFinder.chose_type')"
						:loading="loadingCategories"
						:disabled="!categories.length || isSelectDisabled"
						@change="categoryChange"
						autocomplete="off"
						name="deviceCategory"
						return-object
					/>
				</div>
				<div class="col-md-4">
					<v-autocomplete
						v-model="selectedBrand"
						item-text="name"
						item-value="pk"
						:items="brands"
						:placeholder="$t('buyout.deviceFinder.chose_brand')"
						@change="brandChange"
						:loading="loadingBrands"
						:disabled="!brands.length || !selectedCategory || isSelectDisabled"
						autocomplete="off"
						name="deviceBrand"
						return-object
					/>
				</div>
				<div class="col-md-4">
					<v-autocomplete
						v-model="selectedModel"
						item-text="name"
						item-value="pk"
						:items="models"
						:placeholder="$t('buyout.deviceFinder.chose_model')"
						@change="modelChange"
						:loading="loadingModels"
						:disabled="!models.length || !selectedBrand || isSelectDisabled"
						autocomplete="off"
						name="deviceModel"
						return-object
					/>
				</div>
			</div>
		</form>
		<div
			id="deviceColors"
			class="buyout__devices deviceColors"
			v-if="selectedModel && displayImages"
		>
			<div
				class="buyout__device color-choice"
				v-for="color in colors"
				:key="color.pk"
			>
				<img
					class="buyout__buyout__productImg mx-auto d-block"
					:src="buildAbsoluteURL(color.image ? color.image : notFoundImage)"
					:alt="`phone_image_${color.color.name}`"
					@click="selectProduct(color)"
					@error="imageNotFound"
				/>
				<v-radio-group
					class="radio-group-full-width deviceColors__radioGroup"
					v-model="selectedColor"
					@change="selectProduct()"
					:disabled="isSelectDisabled"
					row
				>
					<v-radio
						:label="color.color.name"
						:color="color.color.hex"
						:value="color"
						:ripple="false"
						name="deviceColor"
					/>
				</v-radio-group>
			</div>
		</div>
	</div>
</template>

<script>
import { VUEX_BUYOUT } from '../../../store/buyout';
import { config } from '../../../config/buyout';
import { changeRouteParam, buildImageUrl } from '../../../../js/buyout';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { GETTER_TYPES } from '../../../store/buyout/_getter-types';
import { MUTATION_TYPES } from '../../../store/buyout/_mutation-types';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';
import { sleep } from '../../../../js/buyout';

export default {
	name: 'DeviceFinder',
	async created() {
		if (!this.categories.length) await this[ACTION_TYPES.LOAD_CATEGORIES]();
	},
	props: {
		displayImages: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE, [
			'appraisal',
			'appraisalLoadError',
			'categories',
			'loadingCategories',
			'brands',
			'loadingBrands',
			'userBuyoutCode',
			'models',
			'loadingModels',
			'colors',
			'isRegistration'
		]),
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.GET_SELECTED_CATEGORY,
			GETTER_TYPES.GET_SELECTED_BRAND,
			GETTER_TYPES.GET_SELECTED_MODEL,
			GETTER_TYPES.GET_SELECTED_COLOR
		]),
		selectedCategory: {
			get() {
				return this[GETTER_TYPES.GET_SELECTED_CATEGORY];
			},
			set(v) {
				this[MUTATION_TYPES.SET_SELECTED_CATEGORY](v);
			}
		},
		selectedBrand: {
			get() {
				return this[GETTER_TYPES.GET_SELECTED_BRAND];
			},
			set(v) {
				this[MUTATION_TYPES.SET_SELECTED_BRAND](v);
			}
		},
		selectedModel: {
			get() {
				return this[GETTER_TYPES.GET_SELECTED_MODEL];
			},
			set(v) {
				return this[MUTATION_TYPES.SET_SELECTED_MODEL](v);
			}
		},
		selectedColor: {
			get() {
				return this[GETTER_TYPES.GET_SELECTED_COLOR];
			},
			set(v) {
				this[MUTATION_TYPES.SET_SELECTED_COLOR](v);
				this.colorChanged();
			}
		},
		isSelectDisabled() {
			return Boolean(this.userBuyoutCode);
		},
		notFoundImage: () => config.not_found_image
	},
	methods: {
		...mapMutations(VUEX_BUYOUT.NAMESPACE, [
			MUTATION_TYPES.SET_SELECTED_CATEGORY,
			MUTATION_TYPES.SET_SELECTED_BRAND,
			MUTATION_TYPES.SET_SELECTED_MODEL,
			MUTATION_TYPES.SET_SELECTED_COLOR
		]),
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.CHANGE_MODEL,
			ACTION_TYPES.CHANGE_BRAND,
			ACTION_TYPES.CHANGE_CATEGORY,
			ACTION_TYPES.LOAD_CATEGORIES,
			ACTION_TYPES.RESET_APPRAISAL,
			ACTION_TYPES.LOAD_APPRAISAL
		]),
		async modelChange() {
			return await this[ACTION_TYPES.CHANGE_MODEL]();
		},
		async brandChange() {
			return await this[ACTION_TYPES.CHANGE_BRAND]();
		},
		async categoryChange() {
			return await this[ACTION_TYPES.CHANGE_CATEGORY]();
		},
		buildAbsoluteURL(endpoint) {
			return buildImageUrl(endpoint);
		},
		async colorChanged() {
			if (
				(this.appraisal || this.appraisalLoadError) &&
				this.selectedColor &&
				this.isRegistration
			) {
				await this[ACTION_TYPES.RESET_APPRAISAL]();
				await this[ACTION_TYPES.LOAD_APPRAISAL]();
				if (config.scrollToElements) {
						await sleep(200);
						this.$scrollTo('#deviceState', {offset:-300,duration: 400});
					}
			}
		},
		async selectProduct(color) {
			if (!this.isSelectDisabled) {
				if (color !== undefined) this.selectedColor = color;

				if (
					config.isURLHandlingEnabled &&
					this.$route.params.color !== this.selectedColor.seo_name
				) {
					await changeRouteParam({
						color: this.selectedColor.seo_name
					});
				}
			}
		},
		imageNotFound(event) {
			event.target.src = buildImageUrl(this.notFoundImage);
		}
	}
}
</script>
